export const API_SENT_LEADS_DEFAULT_LIMIT = 10;
